import React from 'react';
import cx from 'classnames';
import Layout from '../Layout';
import { H1 } from '../../components/BaseElements/BaseElements';
import babyImage from './images/baby.jpg';

import s from './styles/Error.module.scss';

const Error404 = () => (
  <Layout>
    <div className={s.ErrorPage}>
      <H1 className={cx(s.heading, s['heading-left'])}>4</H1>
      <img className={s.image} src={babyImage} alt="Error" draggable="false" />
      <H1 className={cx(s.heading, s['heading-right'])}>4</H1>
    </div>
  </Layout>
);

export default Error404;
